export enum HelpzoneType {
  CHAT = 'CHAT',
  SCRIPTING = 'SCRIPTING',
  SEARCH = 'SEARCH',
  SURVEY = 'SURVEY',
  KNOWLEDGE_BASE = 'KNOWLEDGE_BASE',
}
